// src/pages/ContactUs.js
import React from "react";
import { PopupButton } from "react-calendly";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function ContactUs() {
  return (
    <div>
      {/* Top black section */}
      <section className="contact-top-section">
        <div className="top-container">
          {/* Left text */}
          <div className="top-left">
            <h2 className="reachout-heading">Reach Out</h2>
            <h1 className="giveus-heading">Give Us A Call</h1>
            <p className="contact-paragraph">
              Book a free appointment, get more information, and have your questions answered! 
              Take a moment to connect with us, we’ll get in touch with you promptly.
            </p>
            <PopupButton
              url="https://cal.com/reflexadvisor/30min?embed_domain=yourwebsite.com&embed_type=Inline"
              rootElement={document.getElementById("root")}
              text="Book Free Consultation"
              className="calendly-button"
            />
          </div>

          {/* Right image */}
          <div className="top-right">
            <img 
              src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/docs/contactimg.jpg"
              alt="Contact" 
              className="contact-img" 
            />
          </div>
        </div>
      </section>

      {/* Bottom section */}
      <section className="contact-info-section">
        <h2 className="big-heading">Have Any Questions?</h2>
        <p className="info-paragraph">
          We value your interest and inquiries! If you have any questions, require more information about our services, 
          or would like to discuss how we can tailor our expertise to meet your specific needs, please reach out. 
          Our dedicated team is here to assist you.
        </p>

        <div className="cards-container">
          {/* Phone Card */}
          <div className="location-card">
            <h3 className="location-heading">Phone</h3>
            <p><FaPhone /> +1 647 846 0916</p>
            <p><FaPhone /> +1 647 846 2411</p>
            <p><FaPhone /> +1 437 525 3445</p>
          </div>

          {/* Email Card */}
          <div className="location-card">
            <h3 className="location-heading">Email</h3>
            <p><FaEnvelope /> info@reflexadvisor.com</p>
          </div>

          {/* Address Card */}
          <div className="location-card">
            <h3 className="location-heading">Address</h3>
            <p><FaMapMarkerAlt /> 222 Jarvis St, Toronto, ON M5B 2B8, Canada</p>
          </div>
        </div>
      </section>

      {/* Google Map Section */}
<div className="map-section">
  <h2 className="map-heading">Find Us Here</h2>
  <div className="map-wrapper">
    <iframe
      title="HaulAwayTO Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.0!2d-79.3762!3d43.6566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb2a5f17af9b%3A0x7a3e04279ca5e4e8!2s222%20Jarvis%20St%2C%20Toronto%2C%20ON%20M5B%202B8%2C%20Canada!5e0!3m2!1sen!2sca!4v1700000000000!5m2!1sen!2sca"
      width="100%"
      height="450"
      style={{ border: 0, borderRadius: "16px" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</div>

      {/* Styles */}
      <style>{`
        /* Top section */
        .contact-top-section {
          background: #000;
          color: #fff;
          padding: 80px 20px;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif;
        }
        .top-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 40px;
          max-width: 1200px;
          margin: 0 auto;
          flex-wrap: wrap;
        }
        .top-left {
          flex: 1;
          min-width: 280px;
        }
        .top-right {
          flex: 1;
          display: flex;
          justify-content: center;
          min-width: 280px;
        }
        .contact-img {
          max-width: 100%;
          border-radius: 16px;
        }
        .reachout-heading {
          font-size: 30px;
          font-weight: 700;
          margin: 0;
          color: #7b19bc;
          line-height: 1.1;
        }
        .giveus-heading {
          font-size: 54px;
          font-weight: 800;
          margin: 4px 0;
          color: #fff;
          line-height: 1.1;
        }
        .contact-paragraph {
          margin: 8px 0 12px 0;
          font-size: 17px;
          color: #fff;
          line-height: 1.4;
          max-width: 650px;
          text-align: left;
        }
        .calendly-button {
          margin-top: 8px;
          padding: 12px 28px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          background: #7b19bc;
          color: #fff;
          border: none;
          border-radius: 10px;
          box-shadow: 0 6px 16px rgba(123,25,188,0.25);
          transition: all 0.3s ease;
        }
        .calendly-button:hover {
          background: #000;
          color: #7b19bc;
          border: 2px solid #7b19bc;
          transform: scale(1.03);
          box-shadow: 0 10px 20px rgba(123,25,188,0.35);
        }

        /* Bottom section */
        .contact-info-section {
          background: #fff;
          padding: 80px 20px;
          text-align: center;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif;
        }
        .big-heading {
          font-size: 48px;
          font-weight: 800;
          margin-bottom: 16px;
          color: #7b19bc;
        }
        .info-paragraph {
          font-size: 16px;
          margin-bottom: 40px;
          color: #000;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }
        .cards-container {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }
        .location-card {
          background: #fff;
          padding: 30px 20px;
          border-radius: 12px;
          min-width: 280px;
          max-width: 350px;
          text-align: left;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          transition: box-shadow 0.3s ease;
        }
        .location-card:hover {
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }
        .location-heading {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 16px;
          color: #7b19bc;
        }
        .location-card p {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
          margin: 6px 0;
          color: #000;
        }

        @media (max-width: 992px) {
          .top-container {
            flex-direction: column;
          }
          .cards-container {
            flex-direction: column;
            gap: 20px;
          }
        }

        /* Map Section */
.map-section {
  background: #fff;
  padding: 0 20px 80px 20px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif;
}
.map-heading {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 24px;
  color: #7b19bc;
}
.map-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
      `}</style>
    </div>
  );
}